import { Col, Row, message } from "antd";
import React, { useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOneUser, updateUser } from "redux/features/user";
import { useHistory } from "react-router-dom";

export const PANDUAN = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(true);

  const onFinish = (values) => {
    console.log("Success:", values);
    updateData(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getData = async () => {
    try {
      console.log(user);
      const response = await dispatch(fetchOneUser(user.id)).unwrap();
      setData(response.data);
      setLoading(false);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    console.log("Mulai update dengan data:", values);
    const cleanedPayload = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v !== "")
    );
    try {
      await dispatch(
        updateUser({
          ...cleanedPayload,
          id: user.id,
        })
      ).unwrap();
      message.success("Update berhasil!");
      history.push("/app/settings");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    if (user?.id) {
      getData();
    }
  }, [user.id]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        username: data.username || "",
        email: data.email || "",
        no_phone: data.no_phone || "",
      });
    }
  }, [data, form]); // isi form saat data tersedia

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Panduan</h2>
          <p>Lihat panduan penggunaan aplikasi di link berikut</p>
        </Col>
      </Row>
      <Row>
         <Col xs={24} sm={24} md={24} lg={24}>
          <a href="https://docs.google.com/document/d/17cddSwHjIPjKvKrnX82aZHfG1AgYJ4Yj1BOVR1dTSgM/edit?usp=sharing" target="_blank">Lihat Panduan</a>
        </Col>
      </Row>
    </>
  );
};

export default PANDUAN;
